import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import theme from "../theme";
import { WifiOff } from "@mui/icons-material";

export const BigWifiOff = styled(WifiOff)`
  transform: scale(4);
  color: ${theme.palette.primary.main};
`;

export const NoInternetConnectionTitle = styled(Typography)`
  font-size: 24px;
  font-weight: bold;
  margin-top: 64px;
  color: ${theme.palette.grey[800]};
`;

export const SecondaryInfo = styled(Typography)`
  font-size: 20px;
  margin-top: 20px;
  margin-bottom: 16px;
  font-weight: 500;
  color: ${theme.palette.grey[600]};
`;

export const TertiaryInfo = styled(Typography)`
  font-size: 15px;
  margin-bottom: 30px;
  color: ${theme.palette.grey[600]};
`;
